import axios from 'http.service';

const baseUrl = '/api/v2/contracts/templates';

const uploadTemplate = async (name, file, grouping, uploadYear) => {
    const nameEncoded = encodeURIComponent(name);
    const groupingEncoded = encodeURIComponent(grouping);
    const yearEncoded = encodeURIComponent(uploadYear);
    const query = new URLSearchParams();
    query.append('name', nameEncoded);
    query.append('grouping', groupingEncoded);
    query.append('uploadYear', yearEncoded);
    const url = `${baseUrl}/update?${query.toString()}`;
    const formData = new FormData();
    formData.append('file', file);
    const config = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };
    try {
        const { status } = await axios.post(url, formData, config);
        return status === 201;
    } catch {
        return false;
    }
};

export { uploadTemplate };
